import { FormControl } from '@angular/forms';

export function ValidateTime(control: FormControl): any {
  if (!control.value) return null;
  const time: string = control.value.trim();
  const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
  if (!timeRegex.test(time)) return { invalid: true };
  return null;
}
